const cookiesStatement = {
  id: 'cookies-statement-en',
  title: 'Cookie Statement',
  body: `
    <p>
      business.super-ego.info website uses cookies in order to increase our productivity and improve your user experience, provide certain user functions, as well as to distinguish you from other users while you're using our website and other products and services.
    </p>
    <h4>What are cookies?</h4>
    <p>
      A cookie is a small file that is locally stored in a web browser or a file system on your computer or mobile device. Cookies are used by all websites and have several different functions. We use the following kinds of cookies:
    </p>
    <h4>Functional cookies</h4>
    <p>
      These cookies are necessary for the operation of our services. They include, for example, cookies that allow you to log in to secure areas of our website and access Super Ego Business information.
    </p>
    <h4>Analytical cookies</h4>
    <p>
      These cookies are important to our website because they help us gather statistics, estimate the size of our audience, better understand user experience, and improve quality of the services that we offer to our users.
    </p>
  `
}

export default cookiesStatement
